module.exports = __webpack_public_path__ + "img/top1_1.4b1c1f7d.png";